import { render, staticRenderFns } from "./quick-order-waiting.vue?vue&type=template&id=f9cebe60&scoped=true&"
import script from "./quick-order-waiting.vue?vue&type=script&lang=js&"
export * from "./quick-order-waiting.vue?vue&type=script&lang=js&"
import style0 from "./quick-order-waiting.vue?vue&type=style&index=0&id=f9cebe60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cebe60",
  null
  
)

export default component.exports